import React from 'react'
import { renderRadioButtonGroupField, renderTextField } from './fields'
import { required } from './validators'
import { Field } from 'redux-form'

export default function AirArrangements(props) {
  return (
    <div className="equote-package-additional-details-form--air-arrangements ">
      <div className="equote-package-additional-details-form--input-group">

        <label className="group-label">
        AIRFARE <span style={{ color: 'red' }}>*</span>
      </label>
      </div>
      <div className="equote-package-additional-details-form--air-arrangements-option">
        <Field
          component={renderRadioButtonGroupField}
          name="Require Air Arrangements"
          // label="AIRFARE*"
          options={[
            { label: 'Yes', value: 'Yes' },
            { label: 'No', value: 'No' }
          ]}
          validate={required}
          displayFlex
          question="Do you need airfare arrangements?"
        />
      </div>
      <div
        className={`equote-package-additional-details-form--air-arrangements-location ${
          props.airArrangementsIsRequired === 'Yes' ? '' : 'u-display-none'
        }`}
      >
        <Field
          inputClassName="equote-package-additional-details-form--textInput"
          component={renderTextField}
          name="Where will you fly from"
          label={'Where will you fly from?'}
          displayFlex
        />
      </div>
    </div>
  )
}
